/**
 * Splits a path into an array of segments.
 * @param path - The path to split.
 * @returns The array of path segments.
 */
export const splitPath = (path) => {
    if (path.length === 0)
        return [];
    return path.replace(/(^\/|\/$)/g, '').split('/');
};
